import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const AddMessageIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21 20"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19.3 7.1V2.37A1.42 1.42 0 0 0 17.9 1H2.39c-.37 0-.72.15-.99.4-.26.27-.41.62-.41.98v11.77c0 .37.15.72.41.98.27.26.62.4 1 .4h2.81V19l4.4-3.46h2.06M16.72 9.89v6.26M13.43 13H20" />
    </SVG>
  );
};
